export const ROUTE_NAMES = {
  LIST: 'partners-lead-list',
  CREATE: 'partners-lead-create',
  DETAILS: 'partners-lead-details'
}

const ROUTES = {
  [ROUTE_NAMES.LIST]: {
    name: ROUTE_NAMES.LIST,
    path: 'partner/leads'
  },
  [ROUTE_NAMES.CREATE]: {
    name: ROUTE_NAMES.CREATE,
    path: 'partner/lead'
  },
  [ROUTE_NAMES.DETAILS]: {
    name: ROUTE_NAMES.DETAILS,
    path: 'partner/lead/:id'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.LIST].name,
    path: ROUTES[ROUTE_NAMES.LIST].path,
    component: (resolve) => require(['./views/list'], resolve)
  },
  {
    name: ROUTES[ROUTE_NAMES.CREATE].name,
    path: ROUTES[ROUTE_NAMES.CREATE].path,
    component: (resolve) => require(['./views/create'], resolve)
  },
  {
    name: ROUTES[ROUTE_NAMES.DETAILS].name,
    path: ROUTES[ROUTE_NAMES.DETAILS].path,
    component: (resolve) => require(['./views/details'], resolve),
    props: true
  }
]
